import React from 'react';
import ReactDOM from 'react-dom/client';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import App from './App';
import { useAuth } from './store/auth';
import { theme } from './styles/theme';

import './styles/index.css';

// 启动时初始化认证状态(从 localStorage 恢复登录态),让 ProtectedRoute 知道 initialized
useAuth.getState().init();

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <App />
    </ThemeProvider>
  </React.StrictMode>,
);
